import { DataChangeDomain } from './DateChangeDomain';

export enum DataChangeType {
  INVALIDATE_OBSERVATION = 'INVALIDATE_OBSERVATION',
  INVALIDATE_SESSION = 'INVALIDATE_SESSION',
  RESTORE_OBSERVATION = 'RESTORE_OBSERVATION',
  RESTORE_SESSION = 'RESTORE_SESSION',
  MODIFY_SPIROMETRY_VISIT = 'MODIFY_SPIROMETRY_VISIT',
  MODIFY_REQUEST_TAG = 'MODIFY_REQUEST_TAG',
  MODIFY_SINGLE_ANSWER = 'MODIFY_SINGLE_ANSWER',
  MODIFY_BD_USAGE = 'MODIFY_BD_USAGE',
  MODIFY_IMP_USAGE = 'MODIFY_IMP_USAGE',
  MODIFY_BD_ADMIN_TIME = 'MODIFY_BD_ADMIN_TIME',
  MODIFY_IMP_ADMIN_TIME = 'MODIFY_IMP_ADMIN_TIME',
  INVALIDATE_RESPONSE = 'INVALIDATE_RESPONSE',
  INVALIDATE_MISSED_RESPONSE = 'INVALIDATE_MISSED_RESPONSE',
  CHANGE_ASSOCIATED_VISIT = 'CHANGE_ASSOCIATED_VISIT',
  CHANGE_REASON_FOR_MISSED = 'CHANGE_REASON_FOR_MISSED',
  MODIFY_LOCAL_TIMESTAMP = 'MODIFY_LOCAL_TIMESTAMP',
  RESTORE_INVALIDATED_RESPONSE = 'RESTORE_INVALIDATED_RESPONSE',
  RESTORE_INVALIDATED_MISSED_RESPONSE = 'RESTORE_INVALIDATED_MISSED_RESPONSE',
  ROLLBACK_STATUS = 'ROLLBACK_STATUS',
  CHANGE_DATE_TIME = 'CHANGE_DATE_TIME',
  CHANGE_END_STATUS = 'CHANGE_END_STATUS',
  UNKNOWN = 'UNKNOWN',
}

const domainDataChangeTypes = {
  [DataChangeDomain.QUESTIONNAIRE]: [
    DataChangeType.MODIFY_SINGLE_ANSWER,
    DataChangeType.INVALIDATE_RESPONSE,
    DataChangeType.CHANGE_ASSOCIATED_VISIT,
    DataChangeType.MODIFY_LOCAL_TIMESTAMP,
  ],
  [DataChangeDomain.PATIENT]: [
    DataChangeType.ROLLBACK_STATUS,
    DataChangeType.CHANGE_DATE_TIME,
    DataChangeType.CHANGE_END_STATUS,
  ],
  [DataChangeDomain.DEVICE]: [
    DataChangeType.MODIFY_REQUEST_TAG,
    DataChangeType.MODIFY_SPIROMETRY_VISIT,
    DataChangeType.MODIFY_BD_USAGE,
    DataChangeType.MODIFY_IMP_USAGE,
    DataChangeType.MODIFY_BD_ADMIN_TIME,
    DataChangeType.MODIFY_IMP_ADMIN_TIME,
    DataChangeType.INVALIDATE_SESSION,
    DataChangeType.INVALIDATE_OBSERVATION,
    DataChangeType.RESTORE_OBSERVATION,
  ],
  [DataChangeDomain.UNKNOWN]: [],
};

export const getDataChangeTypesFromDomain = (domain: DataChangeDomain): DataChangeType[] =>
  domainDataChangeTypes[domain];
